<script lang="ts">
	// @ts-nocheck
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Radio, Toggle } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Types
	import type { LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';
	import ToggleAfterLocalAction from './ToggleAfterLocalAction.svelte';

	export let controlOption: LocalControlOptions;
</script>

<div class="d-flex flex-direction-column">
	{#if controlOption.onOffState?.selectBox}
		<Toggle
			id="toggle-gmi3m61"
			class="mb-xs"
			size="m"
			bind:checked={controlOption.onOffState.checked}
		>
			{controlOption.onOffState.label}
		</Toggle>
	{/if}

	<Radio
		id="radio-azzz4lv"
		class="d-inline-flex mb-xs"
		value={true}
		bind:selected={controlOption.params.on}
		disabled={!controlOption.onOffState?.checked}
		size="m"
	>
		{capFirstChar($format('on_action', { default: 'on' }))}
	</Radio>
	<Radio
		id="radio-cj29s88"
		class="d-inline-flex mb-m"
		value={false}
		bind:selected={controlOption.params.on}
		disabled={!controlOption.onOffState?.checked}
		size="m"
	>
		{capFirstChar($format('off_action', { default: 'off' }))}
	</Radio>

	{#if !controlOption.onOffState?.toggle_after_disabled}
		<ToggleAfterLocalAction
			id="toggle-bu89q21"
			bind:controlOption
			disabled={controlOption.onOffState?.selectBox && !controlOption.onOffState.checked}
		/>
	{/if}
</div>
